/* iceberg-ui */
import { Icon } from '@auviknetworks/iceberg-ui';

/* MUI */
import { AvatarGroup, Box, Collapse, Typography } from '@mui/material';

/* Shared */
import { LightTooltip } from 'application/Shared/Components/Tooltips';
import { FontSizes, Sizes } from 'application/Shared/Constants';
import { Browser } from 'objects/Browser';
import React, { useState } from 'react';

export const BrowserWithCollapse = ({ browser }) => {
    const [collapsed, setCollapsed] = useState(false);

    const { userAgent } = browser;

    return (
        <Box marginBottom="8px" data-testid="browserWithCollapse">
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                data-testid="browserExpandedOnClick"
                onClick={() => setCollapsed(!collapsed)}
            >
                <Browser
                    browser={browser}
                    noTooltip
                    containerStyles={{ marginBottom: '0', maxWidth: '268px' }}
                />
                {userAgent && (
                    <Icon
                        size={FontSizes[2]}
                        src={collapsed ? 'ChevronDown' : 'ChevronRight'}
                    />
                )}
            </Box>

            {userAgent && (
                <Collapse in={collapsed} data-testid="collapsedBrowserText">
                    <Typography
                        style={{
                            fontSize: FontSizes[0],
                            marginTop: Sizes[2]
                        }}
                    >
                        {userAgent}
                    </Typography>
                </Collapse>
            )}
        </Box>
    );
};

export const BrowserBubbles = ({ align, browsers, max, tooltipPlacement }) => {
    if (!browsers) {
        return null;
    }

    const sortedBrowsers = browsers
        .filter(Boolean)
        .sort(
            (a, b) =>
                a?.application?.name &&
                `${a?.application?.name}`.localeCompare(b?.application?.name)
        );
    return (
        <Box
            data-testid="browserBubbles"
            display="flex"
            style={{
                justifyContent: align === 'right' ? 'flex-end' : 'flex-start'
            }}
        >
            <LightTooltip
                title={
                    <Box
                        sx={{
                            fontSize: FontSizes[0],
                            fontWeight: 600,
                            marginBottom: '4px',
                            marginTop: '4px',
                            maxHeight: '160px',
                            overflowX: 'hidden',
                            overflowY: 'scroll'
                        }}
                    >
                        {sortedBrowsers?.map((b) => (
                            <BrowserWithCollapse
                                browser={b}
                                key={`browser_${b.id}`}
                            />
                        ))}
                    </Box>
                }
                placement={tooltipPlacement}
                arrow
                slotProps={{
                    tooltip: {
                        sx: {
                            minWidth: '300px'
                        }
                    }
                }}
            >
                <AvatarGroup
                    data-testid="browsersAvatarGroup"
                    max={max}
                    sx={{
                        '&.MuiAvatarGroup-root .MuiAvatar-root': {
                            marginLeft: 0
                        },
                        '&.MuiAvatarGroup-root .MuiAvatarGroup-avatar': {
                            backgroundColor:
                                'avatar.appsAvatarGroup.backgroundColor'
                        },
                        alignItems: 'self-start',
                        justifyContent: 'center'
                    }}
                >
                    {sortedBrowsers.map((browser) => (
                        <Browser
                            browser={browser}
                            key={`browser_${browser.id}`}
                            avatarGroup
                        />
                    ))}
                </AvatarGroup>
            </LightTooltip>
        </Box>
    );
};
